import { comics, categories } from "@/mocks/comics";
import CategoryTabs from "@/components/feature/CategoryTabs";
import ComicCard from "@/components/feature/ComicCard";
import { Link } from "react-router-dom";

export default function CategorySection() {
  const categoryList = categories.filter((c) => c.id !== "all");

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 mt-1">
            多种题材任你选择，找到属于你的漫画世界
          </p>
        </div>

        <div className="flex justify-center mb-10">
          <CategoryTabs
            categories={categoryList}
            activeCategory=""
            variant="card"
          />
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {comics.slice(0, 4).map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-secondary-500 text-background-50 text-sm font-medium rounded-full hover:bg-secondary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            浏览全部分类
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}